<template>
  <v-row>
    <v-col cols="12">
      <gg-loading :loading="loading" type="list-item">
        <div>
          <gg-card v-if="!loading" :outlined="text">
            <gg-card-text>
              <v-row :class="unpaidRowClass">
                <v-col cols="12">
                  <router-link :to="{ name: 'billing' }">← Back to Invoices</router-link>
                </v-col>
                <v-col cols="12" sm="6" class="align-center">
                  <h2 class="text-left ma-0">
                    Invoice #{{ invoice.id }}
                    <v-chip
                      tile
                      class="ma-2 my-0"
                      style="border-radius: 0"
                      :color="`${ isInvoiceUnpaid ? 'red' : 'green' } lighten-1`"
                      text-color="white"
                    >
                      <v-avatar left>
                        <v-icon>
                          {{ isInvoiceUnpaid ? 'mdi-information-outline' : 'mdi-check-bold' }}
                        </v-icon>
                      </v-avatar>
                      {{ invoice.status }}
                    </v-chip>
                  </h2>
                  <br/>
                  <p>
                    <strong>Date Generated:</strong> {{ invoice.date }}
                  </p>
                  <p>
                    <strong>Due Date:</strong> {{ invoice.duedate }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6" class="align-center text-sm-right d-inline">
                  <gg-btn
                    v-if="isInvoiceUnpaid && !text"
                    color="primary"
                    tile
                    :disabled="invoice.balance == 0"
                    @click="openPaymentsModal"
                  >
                    Pay Now
                  </gg-btn>
                  <gg-btn
                    v-show="!text"
                    secondary
                    :to="{ name: 'print_invoice', params: { invoiceid: invoice.id } }"
                    class="ml-2"
                    target="_blank"
                  >
                    Print
                  </gg-btn>
                  <br/><br/>
                </v-col>
              </v-row>
            </gg-card-text>
          </gg-card>
        </div>
      </gg-loading>
    </v-col>
    <v-col cols="12">
      <gg-loading :loading="loading" type="table">
        <div>
          <gg-card v-if="!loading" :outlined="text">
            <gg-card-text>

              <v-row :class="unpaidRowClass">
                <v-col cols="12" md="3">
                  <h4>Customer Address:</h4>
                  <address>
                    <div>{{ decodeHtmlCharCodes(contact.firstname) }} {{ decodeHtmlCharCodes(contact.lastname) }}</div>
                    <div>{{ decodeHtmlCharCodes(contact.companyname) }}</div>
                    <div>{{ decodeHtmlCharCodes(contact.address1) }}</div>
                    <div v-if="contact.address2">{{ decodeHtmlCharCodes(contact.address2) }}</div>
                    <div>{{ decodeHtmlCharCodes(contact.city) }}, {{ decodeHtmlCharCodes(contact.state) }}
                      {{ decodeHtmlCharCodes(contact.postcode) }}, {{ decodeHtmlCharCodes(contact.country) }}
                    </div>
                  </address>
                </v-col>
                <v-col cols="12" md="3">
                  <h4>Payable to:</h4>
                  <address>
                    <div>GreenGeeks LLC</div>
                    <div>3411 Silverside Rd</div>
                    <div>Tatnall Building #104</div>
                    <div>Wilmington, DE 19810, USA.</div>
                    <div><strong>Tax ID: </strong>85-3680919</div>
                  </address>
                  <!-- <p>
                    <b>Invoice Date:</b>
                    {{ invoice.date }}
                  </p>
                  <p>
                    <b>Due Date:</b>
                    {{ invoice.duedate }}
                  </p> -->
                </v-col>

                <!--Invoice description-->
                <v-col cols="12" class="table-dark">
                  <v-data-table :headers="invoice_headers"
                                :items="invoice.lines"
                                hide-default-footer
                                :items-per-page="itemsPerPage"
                                class="invoice-table-row">
                    <template v-slot:item.description="{ item }">
                      {{ decodeHtmlCharCodes(item.description) }}
                    </template>
                  </v-data-table>
                </v-col>

                <!--Total table-->
                <v-col cols="6" offset="6" sm="4" offset-sm="8">
                  <v-simple-table dense class="invoice-table-row">
                    <template v-slot:default>
                      <tbody>
                      <tr>
                        <td>Subtotal</td>
                        <td class="text-right">{{ invoice.subtotal }}</td>
                      </tr>
                      <tr>
                        <td>Taxes</td>
                        <td class="text-right">{{ invoice.tax }}</td>
                      </tr>
                      <tr>
                        <td>Grand Total</td>
                        <td class="text-right">{{ invoice.total }}</td>
                      </tr>
                      <tr v-if="invoice.balance > 0">
                        <td>Balance Outstanding</td>
                        <td class="text-right">{{ invoice.balance }}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </gg-card-text>
          </gg-card>
        </div>
      </gg-loading>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { decodeHtmlCharCodes } from '@/helpers/helpers'

export default {
  name: 'InvoiceBody',
  props: {
    invoice: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    decodeHtmlCharCodes,
    transaction_headers: [
      { text: 'Transaction Date', sortable: false },
      { text: 'Transaction ID', sortable: false },
      { text: 'Description', sortable: false },
      { text: 'Gateway', sortable: false },
      { text: 'Amount', sortable: false }
    ],
    invoice_headers: [
      { text: 'Description', value: 'description', sortable: false },
      { text: 'Price', value: 'amount', sortable: false, align: 'right' },
    ],
  }),
  methods: {
    openPaymentsModal () {
      this.$emit('pay')
    }
  },
  computed: {
    ...mapGetters(['itemsPerPage']),
    statusClass () {
      return this.invoice.status === 'Paid' ? 'green--text' : 'red--text'
    },
    unpaidRowClass () {
      return this.invoice.status === 'Paid' ? '' : 'mx-sm-2'
    },
    isInvoiceUnpaid () {
      return this.invoice.status === 'Unpaid'
    },
    cardClass () {
      return this.text ? '' : 'app-card'
    }
  },
}
</script>

<style lang="scss">
  .invoice-table-row {
    td {
      height: 1.7rem !important;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
